/**
 * Algebra I · Poziom 2 — treść zadań, polski.
 *
 * Prose for a course pack lives beside the shipped item bundles, under
 * content/lang, and never inside src/. Same rule, same reason: src/ carries no
 * language. The pack in src/content/packs imports this file and the registry
 * merges it in behind content/lang/items.*.js.
 *
 * HOUSE STYLE. Uproszczony polski techniczny: jedno słowo, jedno znaczenie;
 * jedno polecenie na zdanie; strona czynna; poniżej dwudziestu słów. Sytuacja
 * to JEDNO zdanie i nigdy nie podaje liczby, której matematyka nie używa.
 */
export default {
  // ------------------------------------------------------------ Poziom 2 · 1
  'l2.ctx.twoHolds': 'Każda ładownia tego frachtowca ma tę samą masę.',
  'l2.ctx.twoBays': 'Dwie wnęki tej platformy mieszczą tę samą liczbę.',
  'l2.ask.holdMass': 'Znajdź rozwiązanie dla zmiennej ${v}$ w tym równaniu.',
  'l2.ctx.gauge': 'Ten wskaźnik trzyma regułę, której nikt nie zapisał.',
  'l2.ask.missingWatch': 'Ile wynosił brakujący odczyt?',
  'l2.why.openBothBrackets': 'Najpierw otwórz oba nawiasy. Do tej pory każda strona jest jedną wielkością.',
  'l2.why.minusEntersEveryTerm': 'Znak minus należy do całego nawiasu, więc wchodzi w każdy wyraz w środku.',
  'l2.why.multiplyBothByBottom': 'Pomnóż obie strony przez {k}. To zdejmuje kreskę ułamka.',
  'l2.why.stepTellsRate': 'Każdy krok wejścia rusza wyjście o {n}. Tempo wynosi {n}.',
  'l2.why.applyRateOnce': 'Zastosuj tempo do wiersza nad luką.',
  'l2.why.stepBackToInput': 'Wyjście ruszyło o jedno tempo, więc wejście ruszyło o jeden krok.',

  // ------------------------------------------------------ nierówności · pytanie
  'l2.ask.whichStatement': 'Nierówność się przechyla. Która obejmuje każde ${v}$, które pasuje?',
  'l2.ask.whichFirstLine': 'Który wiersz jest poprawnym pierwszym ruchem w tym równaniu?',
  'l2.ask.whichBand': 'Ograniczenie stawia próg na wejściach: to dziedzina. Oddaje odczyty, czyli zbiór wartości. Który przedział zawiera każde ${v}$?',
  'l2.ask.leastWhole': 'Jaka jest najmniejsza całkowita wartość ${v}$ w tej nierówności?',
  'l2.ask.mostWhole': 'Jaka jest największa całkowita wartość ${v}$ w tej nierówności?',
  'l2.ask.howManyWhole': 'Ile całkowitych wartości ${v}$ pasuje?',

  // ------------------------------------------------------ nierówności · miejsca
  'l2.ctx.hoist': 'Dźwig ładunkowy odmawia każdego ładunku, który łamie odczyt poniżej.',
  'l2.ask.setHoist': 'Które zdanie podaje każde ${v}$, które on podniesie?',
  'l2.ask.leastHoist': 'Jaka jest najmniejsza całkowita wartość ${v}$, którą on podniesie?',
  'l2.ask.mostHoist': 'Jaka jest największa całkowita wartość ${v}$, którą on podniesie?',
  'l2.ctx.airlock': 'Śluza pracuje tylko dopóki trzyma się odczyt poniżej.',
  'l2.ask.setAirlock': 'Które zdanie podaje każde ${v}$, które ją otwiera?',
  'l2.ask.leastAirlock': 'Jaka jest najmniejsza całkowita wartość ${v}$, która ją otwiera?',
  'l2.ask.mostAirlock': 'Jaka jest największa całkowita wartość ${v}$, która ją otwiera?',
  'l2.ctx.kiln': 'Piec trzyma szkliwo tylko dopóki trzyma się odczyt.',
  'l2.ask.setKiln': 'Które zdanie podaje każde ${v}$, przy którym szkliwo się trzyma?',
  'l2.ask.leastKiln': 'Jaka jest najmniejsza całkowita wartość ${v}$, przy której szkliwo się trzyma?',
  'l2.ask.mostKiln': 'Jaka jest największa całkowita wartość ${v}$, przy której szkliwo się trzyma?',
  'l2.ctx.tether': 'Lina zrywa się w chwili, gdy odczyt poniżej przestaje się trzymać.',
  'l2.ask.setTether': 'Które zdanie podaje każde ${v}$, które jest jeszcze bezpieczne?',
  'l2.ask.leastTether': 'Jaka jest najmniejsza całkowita wartość ${v}$, która jest jeszcze bezpieczna?',
  'l2.ask.mostTether': 'Jaka jest największa całkowita wartość ${v}$, która jest jeszcze bezpieczna?',
  'l2.ctx.thruster': 'Silnik manewrowy pali tylko dopóki trzyma się odczyt poniżej.',
  'l2.ask.setThruster': 'Które zdanie podaje każde ${v}$, przy którym on pali?',
  'l2.ask.leastThruster': 'Jaka jest najmniejsza całkowita wartość ${v}$, przy której on pali?',
  'l2.ask.mostThruster': 'Jaka jest największa całkowita wartość ${v}$, przy której on pali?',

  // ------------------------------------------------------------ przedziały
  'l2.ctx.bandGlaze': 'Szkliwo wiąże tylko między dwiema temperaturami, a piec pokazuje jedną z nich.',
  'l2.ctx.bandHold': 'Ładownia stoi równo tylko między dwiema masami.',
  'l2.ctx.bandSeed': 'Taca z nasionami kiełkuje tylko między dwoma poziomami światła.',
  'l2.ctx.bandTrack': 'Sanie szynowe jadą tylko między dwiema prędkościami.',
  'l2.ask.setBand': 'Który przedział dziedziny i zbioru wartości dopuszcza ograniczenie?',
  'l2.ask.countBand': 'Ile całkowitych wartości ${v}$ leży w przedziale?',

  // ---------------------------------------------------- nierówności · dlaczego
  'l2.why.takeOffBothSides': 'Odejmij {n} od obu stron. Przechył się nie zmienia.',
  'l2.why.addToBothSides': 'Dodaj {n} do obu stron. Przechył się nie zmienia.',
  'l2.why.leanUnchanged': 'Żaden ruch nie mnoży przez liczbę ujemną, więc ta nierówność przechyla się tak samo.',
  'l2.why.leanNowRead': 'Niewiadoma stoi sama. Odczytaj z niej przechył.',
  'l2.why.divideByNegativeTurns': 'Podziel przez {a}, aby odwrócić przechył. Żaden inny ruch tego nie robi.',
  'l2.why.boundaryNotWhole': 'Granica nie jest liczbą całkowitą, więc żadna całkowita na niej nie leży.',
  'l2.why.firstWholePast': 'To pierwsza liczba całkowita za granicą.',
  'l2.why.lastWholeBefore': 'To ostatnia liczba całkowita przed granicą.',
  'l2.why.takeOffEveryPart': 'Odejmij {n} od wszystkich trzech części naraz.',
  'l2.why.addToEveryPart': 'Dodaj {n} do wszystkich trzech części naraz.',
  'l2.why.divideEveryPart': 'Podziel wszystkie trzy części przez {a}. Zbiór wartości zwęża się razem z nimi.',
  'l2.why.divideByNegativeTurnsBoth': 'Dzielenie przez {a} odwraca oba znaki, więc przedział czyta się na odwrót.',
  'l2.why.bandFirst': 'Najpierw znajdź przedział, na który pozwala ograniczenie, dopiero potem licz.',
  'l2.why.countTheEnds': 'Dziedzina biegnie od końca do końca. Policz oba końce, nie tylko odstęp.',

  // ------------------------------------------------------------------ wzory
  'l2.ask.solveFormulaFor': 'Wzór zapisany literami to równanie z literami. Przekształć je tak, aby ${v}$ stało samo.',
  'l2.ask.turnItRound': 'Zostaw zmienną ${v}$ samą.',
  'l2.ctx.fArea': 'Płyta poszycia to prostokąt, a ta reguła podaje jego pole.',
  'l2.ctx.fDistance': 'Sanie jadą ze stałą prędkością, a ta reguła podaje drogę.',
  'l2.ctx.fForce': 'Silnik pcha masę, a ta reguła podaje siłę.',
  'l2.ctx.fTriangle': 'Płat żagla to trójkąt, a ta reguła podaje jego pole.',
  'l2.ctx.fPerimeter': 'Rama biegnie dookoła prostokąta, a ta reguła podaje jej długość.',
  'l2.ctx.fLine': 'Prosty ślad wznosi się w stałym tempie, a ta reguła podaje jego wysokość.',
  'l2.ctx.fStandard': 'Dwa składy ubywają w stałym tempie, a ta reguła podaje sumę.',
  'l2.ctx.fMean': 'Ta reguła uśrednia dwa odczyty i podaje wartość środkową.',
  'l2.ctx.fTerm': 'Drabina odczytów rośnie o ten sam krok, a ta reguła podaje dowolny szczebel.',
  'l2.ctx.fCone': 'Zsyp rudy to stożek, a ta reguła podaje jego objętość.',
  'l2.ctx.fDegrees': 'Ta reguła zamienia jedną skalę temperatury na drugą.',
  'l2.ctx.fInterest': 'Saldo kredytu rośnie w stałym tempie, a ta reguła podaje odsetki.',
  'l2.why.divideBothByLetter': 'Podziel obie strony przez literę stojącą przy ${v}$.',
  'l2.why.divideBothByNumber': 'Podziel obie strony przez liczbę stojącą przy ${v}$.',
  'l2.why.clearTheBarFirst': 'Najpierw usuń kreskę ułamka. Do tego czasu nic innego się nie ruszy.',
  'l2.why.moveTheOtherTermFirst': 'Najpierw przenieś na drugą stronę wyraz, który nie zawiera ${v}$.',
  'l2.why.readItRoundTheOtherWay': 'Równanie z literami pozostaje prawdziwe, gdy czytasz je od drugiej strony.',
  'l2.why.putBackTheOne': 'Nawias trzymał o jeden mniej niż ${v}$, więc dodaj tę jedynkę z powrotem.',

  // --------------------------------------------------------------- stosunki
  'l2.ask.findTheFourth': 'Dwa zgodne stosunki tworzą proporcję. Znajdź brakującą liczbę.',
  'l2.ask.sameRatioRow': 'Każdy wiersz ma ten sam stosunek, więc wiersze tworzą proporcję. Jaki jest brakujący odczyt?',
  'l2.ask.whichProportion': 'Która proporcja zapisuje to poprawnie?',
  'l2.ctx.mix': 'Mieszalnik trzyma w każdej partii ten sam stosunek żywicy do utwardzacza.',
  'l2.ask.mixHowMany': 'Ile utwardzacza bierze większa partia?',
  'l2.ctx.chart': 'Na tej mapie długość na papierze i odległość w terenie trzymają jeden stosunek.',
  'l2.ask.chartHowFar': 'Ile wynosi odległość w terenie?',
  'l2.ctx.alloy': 'Stop trzyma stały stosunek cyny do miedzi.',
  'l2.ask.alloyHowMuch': 'Ile miedzi bierze ten odlew?',
  'l2.ctx.feed': 'Magazyn paszy wydaje na każdej wachcie ten sam stosunek ziarna do kadetów.',
  'l2.ask.feedHowMany': 'Ile ziarna bierze większa wachta?',
  'l2.ctx.dye': 'Kadź barwiarska trzyma ten sam stosunek pigmentu do wody.',
  'l2.ask.dyeHowMuch': 'Ile wody bierze większa kadź?',
  'l2.why.crossMultiply': 'Proporcja daje jedno równanie: pomnóż na krzyż.',
  'l2.why.oneNumberLeft': 'Została jedna niewiadoma, a to już zwykłe równanie.',
  'l2.why.oneRowGivesTheRate': 'Jeden pełny wiersz podaje tempo. Każdy inny wiersz go słucha.',
  'l2.why.applyRateToRow': 'Zastosuj to tempo do wiersza z luką.',
  'l2.why.firstPairIsTheRatio': 'Pierwsze dwie wielkości ustalają stosunek.',
  'l2.why.secondPairMatchesIt': 'Druga para musi trzymać ten sam stosunek, w tej samej kolejności.',

  // ------------------------------------------------------ nachylenie, tempo
  'l2.ask.rateBetweenReadings': 'Dwa odczyty, czyli dwa punkty, leżą na jednej prostej. Jakie jest jej nachylenie, jej tempo?',
  'l2.ask.rateFromTable': 'Wszystkie wiersze słuchają prostej przez punkty. Jaka jest jej szybkość zmian, czyli wzrost na krok?',
  'l2.ask.rateOfTrace': 'Jakie jest nachylenie, czyli szybkość zmian, między dwoma punktami śladu?',
  'l2.ask.ratePerStep': 'Jaka jest szybkość zmian na krok?',
  'l2.ctx.rateWinch': 'Wciągarka wypuszcza linę w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateFrost': 'Szron schodzi po maszcie w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateTank': 'Zbiornik napełnia się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateSled': 'Sanie jadą w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateKiln': 'Piec grzeje w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.why.riseOverRun': 'Nachylenie to wzrost między dwoma punktami, podzielony przez krok w bok.',
  'l2.why.oneStepDownTheTable': 'Zejdź o jeden wiersz w tabeli i podziel wzrost przez krok.',
  'l2.why.thatIsTheRate': 'To jest szybkość zmian, a każda para odczytów daje tę samą.',
  'l2.why.oneStepIsTheRate': 'Jeden krok w bok podaje tempo od razu.',

  // ------------------------------------------------------------------ ślad
  'l2.ask.drawThroughBoth': 'Narysuj wykres, czyli ślad, przez oba odczyty na układzie współrzędnych. Jego wyraz wolny jest tam, gdzie przecina oś pionową.',
  'l2.ask.drawThroughTable': 'Narysuj wykres, czyli ślad, pasujący do każdego wiersza. Jego wyraz wolny leży tam, gdzie przecina oś pionową.',
  'l2.ask.writeTheRule': 'Prosta reguła to funkcja liniowa: nachylenie i początek, czyli wartość początkowa. Która reguła pasuje do każdego odczytu?',
  'l2.ask.writeTheTrace': 'Funkcja liniowa rysuje prosty ślad od wartości początkowej, czyli wyrazu wolnego. Której reguły słucha ten?',
  'l2.ask.traceHeightAt': 'Mapa to układ współrzędnych i już pokazuje ślad. Jaka jest jego wysokość przy $x = {val}$?',
  'l2.ask.traceReaches': 'Mapa to układ współrzędnych i już pokazuje ślad. Gdzie osiąga $y = {val}$?',
  'l2.ctx.ruleLift': 'Winda wznosi się w stałym tempie z podestu nad ziemią.',
  'l2.ctx.ruleDrift': 'Boja dryfuje w stałym tempie od znaku przy brzegu.',
  'l2.ctx.ruleStack': 'Stos rośnie w stałym tempie od palety już położonej.',
  'l2.ctx.ruleBrine': 'Zbiornik solanki napełnia się w stałym tempie od poziomu, który już w nim był.',
  'l2.ask.writeRule': 'Która reguła pasuje do obu odczytów?',
  'l2.ask.drawRule': 'Narysuj wykres na układzie współrzędnych dla obu odczytów.',
  'l2.ask.rateOfStatement': 'To zdanie rysuje prostą przez punkty. Jakie jest jej nachylenie, czyli szybkość zmian?',
  'l2.ask.crossesAcross': 'Gdzie ta prosta przecina oś poziomą?',
  'l2.ask.crossesUpright': 'Gdzie ta prosta przecina oś pionową? Ten odczyt to jej wyraz wolny.',
  'l2.ask.sameLineOtherWay': 'Która reguła rysuje tę samą prostą, z tym samym nachyleniem i wyrazem wolnym?',
  'l2.why.gatherYAlone': 'Przenieś wyraz z $x$ na drugą stronę, aby został tylko wyraz z $y$.',
  'l2.why.divideByCoefOfY': 'Podziel każdy wyraz przez {b}, a $y$ zostanie samo.',
  'l2.why.otherIsZeroAcross': 'Na osi poziomej $y$ wynosi zero, więc wyraz z $y$ znika.',
  'l2.why.otherIsZeroUpright': 'Na osi pionowej $x$ wynosi zero, więc wyraz z $x$ znika.',
  'l2.why.backToTheAxis': 'Cofnij się po układzie współrzędnych do osi, gdzie zaczyna się wykres.',
  'l2.why.startIsTheAxis': 'Odczyt przy zerze to wyraz wolny, tam gdzie wykres przecina oś.',

  // ---------------------------------------------------------------- układy
  'l2.ask.findX': 'Oba zdania tworzą jeden układ równań. Ile wynosi tam $x$?',
  'l2.ask.findY': 'Oba zdania trzymają się w jednym punkcie. Ile wynosi tam $y$?',
  'l2.ask.whichPairHoldsBoth': 'Podstaw każdą parę do tego układu równań. Która para spełnia oba wiersze?',
  'l2.ctx.pairCrates': 'W tej ładowni $x$ liczy skrzynie lekkie, a $y$ liczy ciężkie.',
  'l2.ask.pairHowManyLight': 'Ile jest skrzyń lekkich?',
  'l2.ask.pairHowManyHeavy': 'Ile jest skrzyń ciężkich?',
  'l2.ctx.pairTickets': 'Na tym pokładzie $x$ liczy koje kadeckie, a $y$ liczy koje załogowe.',
  'l2.ask.pairHowManyCadet': 'Ile jest koi kadeckich?',
  'l2.ask.pairHowManyCrew': 'Ile jest koi załogowych?',
  'l2.ctx.pairAlloys': 'W tym odlewie $x$ liczy sztaby cyny, a $y$ liczy sztaby ołowiu.',
  'l2.ask.pairHowManyTin': 'Ile jest sztab cyny?',
  'l2.ask.pairHowManyLead': 'Ile jest sztab ołowiu?',
  'l2.ctx.pairRuns': 'W tym dzienniku $x$ liczy trasy krótkie, a $y$ liczy trasy długie.',
  'l2.ask.pairHowManyShort': 'Ile jest tras krótkich?',
  'l2.ask.pairHowManyLong': 'Ile jest tras długich?',
  'l2.why.putTheRuleIn': 'Pierwszy wiersz układu równań już mówi, ile wynosi $y$. Podstaw go do drugiego.',
  'l2.why.oneLetterAtATime': 'Jednej litery już nie ma, więc zostało zwykłe równanie.',
  'l2.why.backIntoTheRule': 'Wstaw tę wartość z powrotem do reguły, aby wyznaczyć drugą literę.',
  'l2.why.backIntoEitherStatement': 'Wstaw tę wartość z powrotem do dowolnego zdania, aby wyznaczyć drugą literę.',
  'l2.why.addTheStatements': 'Dodaj oba wiersze układu równań. Wyrazy z $y$ są przeciwne, więc $y$ znika.',
  'l2.why.scaleUntilOpposite': 'Pomnóż pierwsze zdanie przez {k}, aby oba wyrazy z $y$ stały się przeciwne.',

  // ------------------------------------------------------- shared questions
  'l2.why.writeTheRuleDown': 'Zapisz funkcję liniową: nachylenie, a potem wartość początkowa.',
  'l2.ask.sameRatioAmount': 'Stosunek się nie zmienia. Jaka jest brakująca ilość?',
  'l2.ask.startAmount': 'Znajdź ${v}$, ilość na starcie.',

  // --- the limit deck — one machine per world, all sharing three questions
  'l2.ctx.limCrane': 'Żuraw nabrzeżny odrzuca ładunek, który łamie odczyt poniżej.',
  'l2.ctx.limPress': 'Prasa poszycia staje, gdy odczyt poniżej zawodzi.',
  'l2.ctx.limPump': 'Pompa zęzowa pracuje tylko przy odczycie poniżej.',
  'l2.ctx.limFilter': 'Filtr powietrza wytrzymuje całą wachtę tylko przy odczycie poniżej.',
  'l2.ctx.limWeld': 'Ramię spawalnicze trzyma szew tylko przy odczycie poniżej.',
  'l2.ctx.limBrake': 'Hamulec szynowy trzyma tor tylko przy odczycie poniżej.',
  'l2.ctx.limDrone': 'Dron pomiarowy zostaje w powietrzu tylko przy odczycie poniżej.',
  'l2.ctx.limCoolant': 'Obieg chłodziwa trzyma rdzeń zimny tylko przy odczycie poniżej.',
  'l2.ctx.limDeck': 'Pokład lądowania przyjmuje statek tylko przy odczycie poniżej.',
  'l2.ctx.limSluice': 'Śluza otwiera się tylko przy odczycie poniżej.',
  'l2.ctx.limForge': 'Kuźnia trzyma żar tylko przy odczycie poniżej.',
  'l2.ctx.limSpar': 'Reja niesie żagiel tylko przy odczycie poniżej.',
  'l2.ctx.limLadder': 'Trap przyjmuje wchodzącego tylko przy odczycie poniżej.',
  'l2.ctx.limVent': 'Szyb wentylacyjny zostaje drożny tylko przy odczycie poniżej.',
  'l2.ctx.limChain': 'Łańcuch kotwiczny trzyma tylko przy odczycie poniżej.',
  'l2.ctx.limSolar': 'Skrzydło słoneczne śledzi słońce tylko przy odczycie poniżej.',
  'l2.ctx.limKettle': 'Kocioł solankowy trzyma wrzenie tylko przy odczycie poniżej.',
  'l2.ctx.limScaffold': 'Rusztowanie stoi tylko przy odczycie poniżej.',
  'l2.ctx.limBeacon': 'Latarnia błyska dalej tylko przy odczycie poniżej.',
  'l2.ctx.limHatch': 'Luk ładunkowy zostaje szczelny tylko przy odczycie poniżej.',
  'l2.ctx.limMill': 'Młyn rudy kręci się tylko przy odczycie poniżej.',
  'l2.ctx.limRelay': 'Maszt przekaźnika odpowiada tylko przy odczycie poniżej.',
  'l2.ctx.limStill': 'Destylator daje czystą wodę tylko przy odczycie poniżej.',
  'l2.ctx.limGrapple': 'Lina z hakiem trzyma kadłub tylko przy odczycie poniżej.',

  // --- the band deck
  'l2.ctx.bandKiln2': 'Piec wypala czysto tylko między dwiema temperaturami, a wskaźnik pokazuje jedną.',
  'l2.ctx.bandPress': 'Prasa zgrzewa płytę tylko między dwoma ciśnieniami.',
  'l2.ctx.bandVat': 'Kadź barwiarska bierze kolor tylko między dwiema temperaturami.',
  'l2.ctx.bandRotor': 'Wirnik pozostaje wyważony tylko między dwiema prędkościami.',
  'l2.ctx.bandTank': 'Zbiornik balastowy trzyma statek równo tylko między dwiema objętościami.',
  'l2.ctx.bandLamp': 'Lampa uprawowa pomaga plonom tylko między dwoma poziomami światła.',
  'l2.ctx.bandWeld': 'Spaw trzyma tylko między dwoma prądami.',
  'l2.ctx.bandLift': 'Winda jedzie bezpiecznie tylko między dwoma obciążeniami.',
  'l2.ctx.bandBrine': 'Rura solankowa zostaje drożna tylko między dwoma poziomami soli.',
  'l2.ctx.bandRelay': 'Przekaźnik odpowiada tylko między dwiema mocami sygnału.',
  'l2.ctx.bandGlider': 'Szybowiec utrzymuje się w górze tylko między dwiema prędkościami.',
  'l2.ctx.bandForge': 'Kuźnia kształtuje żelazo tylko między dwiema temperaturami.',
  'l2.ctx.bandPump': 'Pompa przetacza wodę tylko między dwoma ciśnieniami.',
  'l2.ctx.bandCell': 'Ogniwo paliwowe daje moc tylko między dwiema temperaturami.',
  'l2.ctx.bandNet': 'Włok łowi dobrze tylko między dwiema głębokościami.',
  'l2.ctx.bandOven': 'Piec chlebowy piecze równo tylko między dwiema temperaturami.',
  'l2.ctx.bandMast': 'Maszt stoi bezpiecznie tylko między dwiema prędkościami wiatru.',
  'l2.ctx.bandFilter': 'Filtr wody działa tylko między dwoma przepływami.',
  'l2.ctx.bandCoil': 'Cewka ładująca bierze prąd tylko między dwoma napięciami.',
  'l2.ctx.bandStore': 'Chłodnia trzyma żywność tylko między dwiema temperaturami.',

  // --- the ratio deck
  'l2.ctx.ratioMortar': 'Zaprawa trzyma ten sam stosunek wapna do piasku.',
  'l2.ctx.ratioBrass': 'Odlew mosiądzu trzyma stały stosunek miedzi do cynku.',
  'l2.ctx.ratioInk': 'Prasa drukarska trzyma ten sam stosunek pigmentu do oleju.',
  'l2.ctx.ratioGlaze': 'Szkliwo trzyma ten sam stosunek popiołu do gliny.',
  'l2.ctx.ratioBrine': 'Solanka trzyma ten sam stosunek soli do wody.',
  'l2.ctx.ratioSolder': 'Kąpiel lutownicza trzyma stały stosunek cyny do srebra.',
  'l2.ctx.ratioMap': 'Na tym arkuszu długość na papierze i odległość w terenie trzymają jeden stosunek.',
  'l2.ctx.ratioModel': 'W tym modelu kadłuba długość modelu i rzeczywista trzymają jeden stosunek.',
  'l2.ctx.ratioFeedMix': 'Pasza trzyma ten sam stosunek owsa do jęczmienia.',
  'l2.ctx.ratioFuelMix': 'Mieszanka paliwa trzyma ten sam stosunek spirytusu do oleju.',
  'l2.ctx.ratioConcrete': 'Beton trzyma ten sam stosunek cementu do żwiru.',
  'l2.ctx.ratioTea': 'Kambuzowy kocioł trzyma ten sam stosunek liścia do wody.',
  'l2.ctx.ratioCrew': 'Rozpiska wachty trzyma ten sam stosunek kadetów do oficerów.',
  'l2.ctx.ratioSoil': 'Podłoże trzyma ten sam stosunek torfu do żwirku.',
  'l2.ctx.ratioPaint': 'Partia farby trzyma ten sam stosunek koloru do bazy.',

  // --- the modelling deck — the amounts live in the sentence, because the card shows nothing else
  'l2.ctx.modelResin': 'Mieszanka bierze ${a}$ żywicy na ${b}$ utwardzacza. Następna bierze ${e}$ utwardzacza.',
  'l2.ctx.modelLime': 'Zaprawa bierze ${a}$ wapna na ${b}$ piasku. Następna bierze ${e}$ piasku.',
  'l2.ctx.modelCopper': 'Odlew bierze ${a}$ cyny na ${b}$ miedzi. Następny bierze ${e}$ miedzi.',
  'l2.ctx.modelPigment': 'Kadź bierze ${a}$ pigmentu na ${b}$ wody. Następna bierze ${e}$ wody.',
  'l2.ctx.modelGrain': 'Magazyn daje ${a}$ ziarna na ${b}$ kadetów. Następna wachta ma ${e}$ kadetów.',
  'l2.ctx.modelCement': 'Partia bierze ${a}$ cementu na ${b}$ żwiru. Następna bierze ${e}$ żwiru.',
  'l2.ctx.modelSalt': 'Solanka bierze ${a}$ soli na ${b}$ wody. Następna bierze ${e}$ wody.',
  'l2.ctx.modelOats': 'Pasza bierze ${a}$ owsa na ${b}$ jęczmienia. Następna bierze ${e}$ jęczmienia.',
  'l2.ctx.modelSpirit': 'Paliwo bierze ${a}$ spirytusu na ${b}$ oleju. Następne bierze ${e}$ oleju.',
  'l2.ctx.modelAsh': 'Szkliwo bierze ${a}$ popiołu na ${b}$ gliny. Następne bierze ${e}$ gliny.',
  'l2.ctx.modelPeat': 'Podłoże bierze ${a}$ torfu na ${b}$ żwirku. Następne bierze ${e}$ żwirku.',
  'l2.ctx.modelSilver': 'Kąpiel bierze ${a}$ srebra na ${b}$ cyny. Następna bierze ${e}$ cyny.',
  'l2.ctx.modelLeaf': 'Kocioł bierze ${a}$ liścia na ${b}$ wody. Następny bierze ${e}$ wody.',
  'l2.ctx.modelColour': 'Partia bierze ${a}$ koloru na ${b}$ bazy. Następna bierze ${e}$ bazy.',
  'l2.ctx.modelCadet': 'Rozpiska ma ${a}$ kadetów na ${b}$ oficerów. Następna ma ${e}$ oficerów.',
  'l2.ctx.modelWax': 'Garnek bierze ${a}$ wosku na ${b}$ knota. Następny bierze ${e}$ knota.',

  // --- the rate deck
  'l2.ctx.rateLift': 'Winda wznosi się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateDrill': 'Wiertło schodzi w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateSnow': 'Śnieg narasta w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateStore': 'Magazyn pustoszeje w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateBuoy': 'Boja dryfuje w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateCharge': 'Akumulator ładuje się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateTide': 'Przypływ opada w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateSpool': 'Szpula rozwija się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateGlacier': 'Lodowiec pełznie w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateSilo': 'Silos napełnia się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateCandle': 'Świeca wypala się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateRust': 'Rdza rozchodzi się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateBelt': 'Taśma wiezie rudę w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateSap': 'Sok płynie w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateDust': 'Pył osiada w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateWell': 'Studnia opada w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateCable': 'Lina oblodza się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateSaw': 'Piła tnie w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateVault': 'Bank nasion napełnia się w stałym tempie, a dziennik ma dwa odczyty.',
  'l2.ctx.rateWax': 'Blok wosku topi się w stałym tempie, a dziennik ma dwa odczyty.',

  // --- the rule deck — a steady climb from a start that is not zero
  'l2.ctx.ruleCrane': 'Hak żurawia wznosi się w stałym tempie z ustalonej już wysokości.',
  'l2.ctx.ruleSilo': 'Silos napełnia się w stałym tempie od poziomu, który już w nim był.',
  'l2.ctx.ruleDrill': 'Wiertło schodzi w stałym tempie od głębokości już wyciętej.',
  'l2.ctx.ruleCredit': 'Kredyt rośnie w stałym tempie od salda, które już jest.',
  'l2.ctx.ruleReef': 'Rafa rośnie w stałym tempie od ławicy, która już tam jest.',
  'l2.ctx.ruleSnowline': 'Linia śniegu wznosi się w stałym tempie od znaku już zrobionego.',
  'l2.ctx.ruleSpoil': 'Hałda rośnie w stałym tempie od zwału już wysypanego.',
  'l2.ctx.ruleSail': 'Żagiel luzuje się w stałym tempie od długości już wybranej.',
  'l2.ctx.ruleWard': 'Liczba pacjentów rośnie w stałym tempie od liczby już przyjętej.',
  'l2.ctx.ruleTrench': 'Rów wydłuża się w stałym tempie od odcinka już wykopanego.',
  'l2.ctx.ruleKilnRule': 'Piec grzeje w stałym tempie od temperatury już osiągniętej.',
  'l2.ctx.ruleOrchard': 'Sad rodzi w stałym tempie od zbioru już zebranego.',
  'l2.ctx.ruleRoad': 'Droga wydłuża się w stałym tempie od odcinka już położonego.',
  'l2.ctx.ruleWater': 'Beczka deszczowa napełnia się w stałym tempie od poziomu, który już był.',
  'l2.ctx.ruleFleet': 'Flota rośnie w stałym tempie od liczby już stojącej w doku.',
  'l2.ctx.ruleMast': 'Maszt rośnie w stałym tempie od sekcji już postawionej.',
  'l2.ctx.ruleArchive': 'Archiwum rośnie w stałym tempie od półki już zapełnionej.',
  'l2.ctx.ruleGlass': 'Szklarnia nagrzewa się w stałym tempie od temperatury już ustalonej.',
  'l2.ctx.ruleWall': 'Falochron rośnie w stałym tempie od warstwy już położonej.',
  'l2.ctx.ruleFund': 'Fundusz rośnie w stałym tempie od sumy już zdeponowanej.',

  // --- the paired-hold deck
  'l2.ctx.holdPallets': 'Dwa stosy palet na tym nabrzeżu ważą tyle samo.',
  'l2.ctx.holdCrates': 'Dwa rzędy skrzyń w tej szopie mają tyle samo sztuk.',
  'l2.ctx.holdTanks': 'Dwa zbiorniki na tej platformie mają tę samą objętość.',
  'l2.ctx.holdBays': 'Dwa stanowiska załadunku biorą tę samą masę na każdej wachcie.',
  'l2.ctx.holdRacks': 'Dwa stojaki rdzeni w tym laboratorium mają tyle samo sztuk.',
  'l2.ctx.holdSpools': 'Dwie szpule liny w tym magazynie mają tę samą długość.',
  'l2.ctx.holdKilns': 'Dwa piece na tym placu wypalają ten sam wsad.',
  'l2.ctx.holdBins': 'Dwa kosze ziarna w tym gospodarstwie mają tę samą masę.',
  'l2.ctx.holdWings': 'Dwa skrzydła tej stacji mieszczą tę samą załogę.',
  'l2.ctx.holdSleds': 'Dwoje sań na tej trasie ciągnie tę samą masę.',
  'l2.ctx.holdVats': 'Dwie kadzie barwiarskie w tym zakładzie mają tę samą objętość.',
  'l2.ctx.holdBeds': 'Dwie rozsadniki w tej szkółce biorą tyle samo sztuk.',
  'l2.ctx.holdBanks': 'Dwie baterie ogniw w tym panelu dają tę samą moc.',
  'l2.ctx.holdHoppers': 'Dwa zsypy rudy przy tym szybie mają tę samą masę.',
  'l2.ctx.holdChests': 'Dwie apteczki na tym statku mają tyle samo sztuk.',
  'l2.ctx.holdRolls': 'Dwie bele płótna w tej żaglowni mają tę samą długość.',
  'l2.ctx.holdCarts': 'Dwa wozy urobku na tej linii wiozą tę samą masę.',
  'l2.ctx.holdWells': 'Dwie studnie na tej działce dają tę samą objętość.',
  'l2.ctx.holdRuns': 'Dwie trasy pomiarowe w tym tygodniu pokrywają tę samą odległość.',
  'l2.ctx.holdLofts': 'Dwa spichrze w tej wieży mają tę samą masę.',

  // --- the split deck — spare stock added, then the lot divided
  'l2.ctx.shareRun': 'Załoga dokłada zapas do wysyłki, a potem dzieli całość na równe partie.',
  'l2.ctx.shareCable': 'Takielarz dokłada zapas liny do zwoju, a potem tnie go na równe odcinki.',
  'l2.ctx.shareWater': 'Kucharz dolewa zapas wody do zbiornika, a potem czerpie ją w równe kanistry.',
  'l2.ctx.shareOre': 'Górnik dokłada zapas rudy do hałdy, a potem ładuje ją do równych wózków.',
  'l2.ctx.shareSeed': 'Ogrodnik dosypuje zapas nasion do worka, a potem sieje je na równe grządki.',
  'l2.ctx.shareFuel': 'Mechanik dolewa zapas paliwa do beczki, a potem podaje je w równych dawkach.',
  'l2.ctx.shareRope': 'Bosman dokłada zapas liny do wiązki, a potem tnie ją na równe odcinki.',
  'l2.ctx.shareGrain': 'Młynarz dosypuje zapas ziarna do kosza, a potem pakuje je w równe worki.',
  'l2.ctx.shareSalt': 'Kucharz dosypuje zapas soli do skrzyni, a potem prasuje ją w równe bloki.',
  'l2.ctx.shareWax': 'Świecarz dokłada zapas wosku do garnka, a potem leje go w równe świece.',
  'l2.ctx.shareCanvas': 'Żaglomistrz dokłada zapas płótna do beli, a potem tnie je na równe płaty.',
  'l2.ctx.shareDose': 'Medyk dokłada zapas do apteczki, a potem dzieli go na równe dawki.',
  'l2.ctx.shareCharge': 'Mechanik dokłada zapas ładunku do baterii, a potem pobiera go równymi porcjami.',
  'l2.ctx.sharePaint': 'Malarz dolewa zapas farby do beczki, a potem leje ją w równe puszki.',
  'l2.ctx.shareIce': 'Rębacz dokłada zapas lodu do składu, a potem dzieli go na równe bloki.',
  'l2.ctx.shareTape': 'Monter dokłada zapas taśmy do szpuli, a potem tnie ją na równe paski.',
  'l2.ctx.shareClay': 'Garncarz dokłada zapas gliny do masy, a potem dzieli ją na równe kule.',
  'l2.ctx.shareTimber': 'Cieśla dokłada zapas drewna do stosu, a potem tnie je na równe belki.',
  'l2.ctx.shareThread': 'Tkacz dokłada zapas nici do motka, a potem nawija je na równe szpulki.',
  'l2.ctx.shareSand': 'Formierz dosypuje zapas piasku do kupy, a potem napełnia nim równe formy.',

  // --- the log deck
  'l2.ctx.gaugeLog': 'Ten dziennik wachty trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeDial': 'Ta tarcza trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeTide': 'Ta tablica pływów trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeFuel': 'Ten miernik paliwa trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeDepth': 'Ta sonda głębokości trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeHeat': 'Ten dziennik ciepła trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeYield': 'Ta karta plonu trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeSalt': 'Ten odczyt soli trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeWind': 'Ten zapis wiatru trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeSpin': 'Ten licznik wirnika trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeDose': 'Ta karta dawek trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeLoad': 'Ta karta ładunku trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugePower': 'Ten dziennik mocy trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeFrost': 'Ten zapis szronu trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeSpool': 'Ten licznik szpuli trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeStock': 'Ta księga zapasów trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeSignal': 'Ten dziennik sygnału trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeGrain': 'Ten rachunek ziarna trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeAir': 'Ten miernik powietrza trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeSpeed': 'Ten zapis prędkości trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeIce': 'Ta karta rdzeni lodowych trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeWater': 'Ta tablica poziomu wody trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeTally': 'Ten rachunek załogi trzyma regułę, której nikt nie zapisał.',
  'l2.ctx.gaugeRelay': 'Ten licznik przekaźnika trzyma regułę, której nikt nie zapisał.',

  // --- the two-condition deck — every sentence binds its letters
  'l2.ctx.pairSacks': 'Tu $x$ liczy worki pełne, a $y$ liczy worki niepełne.',
  'l2.ctx.pairLamps': 'Tu $x$ liczy lampy pokładowe, a $y$ liczy lampy ładowni.',
  'l2.ctx.pairPanes': 'Tu $x$ liczy szyby czyste, a $y$ liczy szyby matowe.',
  'l2.ctx.pairSeeds': 'Tu $x$ liczy tace nasion, a $y$ liczy tace sadzonek.',
  'l2.ctx.pairDrums': 'Tu $x$ liczy beczki paliwa, a $y$ liczy beczki wody.',
  'l2.ctx.pairPlates': 'Tu $x$ liczy płyty poszycia, a $y$ liczy płyty pokładu.',
  'l2.ctx.pairCores': 'Tu $x$ liczy rdzenie lodowe, a $y$ liczy rdzenie skalne.',
  'l2.ctx.pairSleds': 'Tu $x$ liczy sanie lekkie, a $y$ liczy sanie ciężkie.',
  'l2.ctx.pairSpools': 'Tu $x$ liczy szpule krótkie, a $y$ liczy szpule długie.',
  'l2.ctx.pairCans': 'Tu $x$ liczy kanistry wody, a $y$ liczy kanistry oleju.',
  'l2.ctx.pairBricks': 'Tu $x$ liczy cegły wypalone, a $y$ liczy cegły surowe.',
  'l2.ctx.pairFlares': 'Tu $x$ liczy race dzienne, a $y$ liczy race nocne.',
  'l2.ctx.pairRolls': 'Tu $x$ liczy bele płótna, a $y$ liczy bele sieci.',
  'l2.ctx.pairCells': 'Tu $x$ liczy ogniwa nowe, a $y$ liczy ogniwa zużyte.',
  'l2.ctx.pairDoses': 'Tu $x$ liczy dawki ciepłe, a $y$ liczy dawki zimne.',
  'l2.ctx.pairBuoys': 'Tu $x$ liczy boje świecące, a $y$ liczy boje ciemne.',
  'l2.ctx.pairStakes': 'Tu $x$ liczy paliki krótkie, a $y$ liczy paliki długie.',
  'l2.ctx.pairKilns': 'Tu $x$ liczy piece gorące, a $y$ liczy piece zimne.',
  'l2.ctx.pairSpars': 'Tu $x$ liczy reje drewniane, a $y$ liczy reje metalowe.',
  'l2.ctx.pairPumps': 'Tu $x$ liczy pompy ręczne, a $y$ liczy pompy silnikowe.',


  // --- ten more formulas, so a band deals from four situations and not two
  'l2.ctx.fSquare': 'Pokrywa luku to kwadrat, a ta reguła podaje jej obwód.',
  'l2.ctx.fDensity': 'Blok ma stałą gęstość, a ta reguła podaje jego masę.',
  'l2.ctx.fCost': 'Magazyn sprzedaje części po jednej cenie, a ta reguła podaje rachunek.',
  'l2.ctx.fBox': 'Skrzynia ładunkowa to prostopadłościan, a ta reguła podaje jej objętość.',
  'l2.ctx.fTriFrame': 'Listwa biegnie dookoła trójkąta, a ta reguła podaje jej długość.',
  'l2.ctx.fSpeedUp': 'Sanie przyspieszają w stałym tempie, a ta reguła podaje ich prędkość.',
  'l2.ctx.fTrapezoid': 'Panel poszycia to trapez, a ta reguła podaje jego pole.',
  'l2.ctx.fThreeMean': 'Ta reguła uśrednia trzy odczyty i podaje wartość środkową.',
  'l2.ctx.fBalance': 'Saldo kredytu rośnie w stałym tempie, a ta reguła podaje sumę.',
  'l2.ctx.fLadderSum': 'Drabina odczytów rośnie o ten sam krok, a ta reguła podaje sumę.',

  // --- the dispute deck: both readings printed, so the question can point at them
  'l2.ctx.dispChalk': 'Jeden kadet pisze ${a}$. Drugi pisze pod spodem ${b}$.',
  'l2.ctx.dispLog': 'Dziennik ma ${a}$ jedną ręką i ${b}$ drugą.',
  'l2.ctx.dispRadio': 'Jedna konsola nadaje ${a}$. Druga nadaje ${b}$.',
  'l2.ctx.dispSlate': 'Na tabliczce stoi ${a}$, a ktoś dopisał obok ${b}$.',
  'l2.ctx.dispWatch': 'Wachta poranna zapisała ${a}$. Nocna zapisała ${b}$.',
  'l2.ctx.dispQuarrel': 'Dwaj kadeci nie mogą mieć obaj racji. Jeden wpisał ${a}$, drugi ${b}$.',
  'l2.ctx.dispAudit': 'Audyt przyjmie jeden odczyt: ${a}$ albo ${b}$.',
  'l2.ctx.dispWager': 'Jeden kadet wpisał ${a}$. Drugi wpisał ${b}$, a kuchnia w zakładzie.',
  'l2.ctx.dispBridge': 'Mostek ma ${a}$ i ${b}$, a chce jednego odczytu.',
  'l2.ctx.dispPost': 'Tablica pokazuje ${a}$ przypięte nad ${b}$.',
  'l2.ctx.dispDrill': 'Dwóch kadetów zrobiło to samo ćwiczenie. Jeden ma ${a}$, drugi ${b}$.',
  'l2.ctx.dispInk': 'Arkusz ma ${a}$ i ${b}$ tym samym atramentem.',
};
